var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        class: [
          _vm.index === 0 ? "mt-3" : "mt-8",
          "flex items-center justify-between mb-4",
        ],
      },
      [
        _c(
          "div",
          { staticClass: "flex items-center" },
          [
            _c(
              "div",
              {
                staticClass: "text-lg inline-block mr-2 cursor-pointer",
                on: {
                  click: function ($event) {
                    return _vm.handleGoList(_vm.classifyItem)
                  },
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.isZh ? _vm.classifyItem.name : _vm.classifyItem.nameEn
                    ) +
                    " "
                ),
              ]
            ),
            _c("van-icon", {
              staticClass: "cursor-pointer",
              attrs: { name: "arrow" },
              on: {
                click: function ($event) {
                  return _vm.handleGoList(_vm.classifyItem)
                },
              },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "hidden md:flex items-center gap-2" }, [
          _c(
            "button",
            {
              staticClass: "nav-arrow",
              class: { "nav-arrow-disabled": !_vm.canScrollLeft },
              attrs: { disabled: !_vm.canScrollLeft, "aria-label": "向左滚动" },
              on: { click: _vm.scrollLeft },
            },
            [
              _c("van-icon", {
                attrs: {
                  name: "arrow-left",
                  size: "14",
                  color: _vm.canScrollLeft ? "#333" : "#ccc",
                },
              }),
            ],
            1
          ),
          _c(
            "button",
            {
              staticClass: "nav-arrow",
              class: { "nav-arrow-disabled": !_vm.canScrollRight },
              attrs: {
                disabled: !_vm.canScrollRight,
                "aria-label": "向右滚动",
              },
              on: { click: _vm.scrollRight },
            },
            [
              _c("van-icon", {
                attrs: {
                  name: "arrow",
                  size: "14",
                  color: _vm.canScrollRight ? "#333" : "#ccc",
                },
              }),
            ],
            1
          ),
        ]),
      ]
    ),
    _c("div", { staticClass: "scroll-wrapper" }, [
      _c(
        "div",
        {
          ref: "scrollContainer",
          staticClass: "scroll-container overflow-x-auto scrollbar-hide",
          on: { scroll: _vm.handleScroll },
        },
        [
          _c(
            "div",
            { staticClass: "scroll-content flex gap-4" },
            _vm._l(_vm.items, function (item) {
              return _c(
                "div",
                {
                  key: item.id,
                  staticClass:
                    "scroll-item flex-shrink-0 cursor-pointer relative",
                  style: { width: _vm.itemWidth },
                  on: {
                    click: function ($event) {
                      return _vm.handleClick(item)
                    },
                  },
                },
                [
                  _c("img", {
                    staticClass: "rounded-lg w-full aspect-square object-cover",
                    attrs: { src: _vm.imageBaseUrl + item.picUrl, alt: "" },
                  }),
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex items-center justify-between mt-2 mb-1",
                    },
                    [
                      _c(
                        "h3",
                        {
                          staticClass:
                            "text-sm font-semibold text-gray-800 truncate pr-2",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$store.getters.isZh
                                  ? item.name
                                  : item.nameEn
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c("van-icon", {
                    staticClass: "absolute top-2 right-2",
                    attrs: {
                      name: item.favorite ? "like" : "like-o",
                      color: item.favorite ? "#ff7a00" : "#999",
                      size: "28",
                    },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.handleFavorite(item)
                      },
                    },
                  }),
                  _c(
                    "span",
                    {
                      staticClass:
                        "absolute top-2 left-2 text-xs text-orange-600 bg-white px-3 py-1 rounded-full border border-gray-300",
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.classifyItem.type === "SIM" ? "SIM" : "eSIM"
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c("div", { staticClass: "pl-2" }, [
                    _c("div", { staticClass: "text-md text-gray-800" }, [
                      _vm._v(_vm._s(_vm.isZh ? item.place : item.placeEn)),
                    ]),
                    _c("span", { staticClass: "text-xs text-gray-500" }, [
                      _vm._v(
                        _vm._s(item.favoriteCount) +
                          _vm._s(_vm.$t("home.favoriteCount"))
                      ),
                    ]),
                  ]),
                ],
                1
              )
            }),
            0
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }